export const API_ROOT = "/api";

export const HEADERS = Object.freeze({
    apiVersion: "X-ApiVersion",
    minimalSchema: "minimalSchema",
    location: "Location",
});

export const EXTENSION_DATA_KEYS = Object.freeze({
    minimalSchema: "minimal_schema_list",
});

export const QUERY = Object.freeze({
    templateName: "entities_by_query",
});

export const SCROLL = Object.freeze({
    templateName: "entities_by_scroll",
});

export const SEARCH_AFTER = Object.freeze({
    templateName: "entities_by_SearchAfter",
});

export const DATA_SOURCES = Object.freeze({
    templateName: "datasources",
});

export const DATA_SOURCE_BY_NAME = Object.freeze({
    templateName: "datasource_by_name",
    name: "name",
});

export const ENTITIES = Object.freeze({
    templateName: "entities",
});

export const ENTITY_BY_ID = Object.freeze({
    templateName: "entity_by_id",
    id: "id",
    culture: "culture",
});

export const ENTITY_BY_IDENTIFIER = Object.freeze({
    templateName: "entity_by_identifier",
    identifier: "identifier",
});

export const ENTITY_RELATION_BY_NAME = Object.freeze({
    templateName: "entity_relation_by_name",
    id: "id",
    name: "name",
});

export const POLICY_BY_ID = Object.freeze({
    templateName: "policy_by_id",
    id: "id",
});

export const ENTITY_DEFINITIONS = Object.freeze({
    templateName: "entitydefinitions",
    skip: "skip",
    take: "take",
    filter: "filter",
    definitionsToLoad: "definitionsToLoad",
    definitionsToLoadByName: "definitionsToLoadByName",
    definitionsToLoadById: "definitionsToLoadById",
    viewMode: "viewMode",
    loadPermissions: "loadPermissions",
    includeConditionalMembers: "includeConditionalMembers",
    excludeTaxonomyDefinitions: "excludeTaxonomyDefinitions",
    excludeSystemOwnedDefinitions: "excludeSystemOwnedDefinitions",
    excludeLightDefinitions: "excludeLightDefinitions",
});

export const ENTITY_DEFINITION_BY_NAME = Object.freeze({
    templateName: "entitydefinition_by_name",
    name: "name",
    includeConditionalMembers: "includeConditionalMembers",
    loadPermissions: "loadPermissions",
});

export const ENTITY_DEFINITION_BY_NAME_V2 = Object.freeze({
    templateName: "entitydefinition_by_name_v2",
    name: "name",
    includeConditionalMembers: "includeConditionalMembers",
    loadPermissions: "loadPermissions",
});

export const ENTITY_DEFINITION_BY_ID = Object.freeze({
    templateName: "entitydefinition_by_id",
    id: "id",
    includeConditionalMembers: "includeConditionalMembers",
    loadPermissions: "loadPermissions",
});

export const FETCH_JOBS = Object.freeze({
    templateName: "fetchjobs",
});

export const FETCH_JOB_BY_ID = Object.freeze({
    templateName: "fetchjobs_by_id",
    id: "id",
});

export const PERMISSIONS_FOR_ENTITY = Object.freeze({
    templateName: "permissions_for_entity",
    id: "id",
});

export const EXPLAIN_USER_PERMISSIONS_FOR_ENTITY = Object.freeze({
    templateName: "explain_permissions",
    id: "id",
    userId: "userId",
});

export const COMMANDS = Object.freeze({
    templateName: "commands",
    folder: "folder",
    command: "command",
});

export const SEND_CONFIRMATION_MAIL = Object.freeze({
    templateName: "send_confirmation_email",
    userId: "userId",
});

export const SEND_NOTIFICATION = Object.freeze({
    templateName: "send_notification",
    type: "type",
});

export const DOWNLOAD_ORDER_BY_ID = Object.freeze({
    templateName: "download_orders_by_id",
    id: "id",
});

export const PACKAGE = Object.freeze({
    templateName: "package",
});

export const EXECUTE_SCRIPT = Object.freeze({
    templateName: "execute_script",
    identifier: "identifier",
});

export const SET_USER_PASSWORD = Object.freeze({
    templateName: "set_user_password",
    userId: "userId",
});

export const RESET_PASSWORD = Object.freeze({
    templateName: "reset_password",
    userId: "userId",
});

export const AGGREGATES = Object.freeze({
    templateName: "aggregates",
    name: "name",
    id: "id",
    culture: "culture",
    loadPermissions: "loadPermissions",
    loadOptionLists: "loadOptionLists",
    loadSettings: "loadSettings",
    loadDefinitions: "loadDefinitions",
    loadEntities: "loadEntities",
});

export const PAGE_BY_IDENTIFIER = Object.freeze({
    templateName: "page_by_identifier",
    identifier: "identifier",
    culture: "culture",
    entityId: "entityId",
});

export const PAGE_BY_ID = Object.freeze({
    templateName: "page_by_id",
    id: "id",
    culture: "culture",
    entityId: "entityId",
});

export const SEARCH = Object.freeze({
    templateName: "search",
});

export const ALL_FACETS = Object.freeze({
    templateName: "allfacets",
});

export const UPLOAD = Object.freeze({
    templateName: "upload",
});

export const UPLOAD_FINALIZE = Object.freeze({
    templateName: "upload_finalize",
});

export const COPY_ENTITY = Object.freeze({
    templateName: "copy",
    id: "id",
});

export const SETTING = Object.freeze({
    templateName: "setting_by_name",
    category: "category",
    name: "name",
});
